module.exports = __webpack_public_path__ + "img/soth-trivia-screen-machine.319c6286.png";